exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#AccountCancellation {\n  padding: 0.16rem;\n  font-size: 0.15rem;\n  color: #1E283C;\n}\n#AccountCancellation h2 {\n  font-size: 0.18rem;\n}\n#AccountCancellation h3 {\n  margin: 0.05rem 0;\n  font-size: 0.15rem;\n}\n#AccountCancellation section {\n  margin: 0.12rem 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/accountCancellation2/index.less
// module id = 344
// module chunks = 0